import { Info } from "lucide-react";

export function InfoCallout({ label, text }: { label: string; text: string }) {
  return (
    <div className="rounded-xl border border-primary/10 bg-primary/10 p-4">
      <div className="flex items-start gap-3">
        <Info className="mt-0.5 h-5 w-5 shrink-0 text-primary" strokeWidth={1.8} />
        <p className="text-sm leading-5 text-primary">
          <strong>{label}</strong> {text}
        </p>
      </div>
    </div>
  );
}
